/* eslint-disable react/no-array-index-key */
import { Avatar } from 'antd';
import React from 'react';

const AvatarGroup: React.FC<{
  max?: number;
  sources: string[];
}> = ({ sources = [], max = 3 }) => (
  <Avatar.Group>
    {sources.slice(0, sources.length > max ? max : sources.length).map((src, index) => (
      <Avatar key={index} src={src} />
    ))}
  </Avatar.Group>
);

export default AvatarGroup;
